import React from "react";
import { LegalLayout } from "../../components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. About these Terms",
    body: [
      "These Terms of Use (\u201cTerms\u201d) govern your access to and use of ATLAS (\u201cAtlas\u201d, \u201cwe\u201d, \u201cus\u201d), a European vehicle discovery, comparison and intelligence platform. By creating an account or using Atlas, you agree to these Terms.",
      "This is a prototype. The document is a draft prepared for future review by qualified Netherlands/EU counsel. It does not yet constitute final, binding legal terms and Atlas makes no representation that it is legally compliant or certified.",
    ],
  },
  {
    heading: "2. What Atlas is — and is not",
    body: [
      "Atlas aggregates, normalizes and analyzes vehicle information from third-party sources so users can find and compare opportunities across European markets. Atlas provides information and decision support only.",
      "Atlas is not a vehicle seller, dealer, broker, marketplace, auction house, payment processor or escrow service. Atlas does not sell vehicles, process vehicle payments, accept deposits or act as escrow.",
    ],
  },
  {
    heading: "3. No transactions through Atlas",
    body: [
      "All transactions occur directly between you and the original source or seller. Atlas will never ask users to send money to secure or purchase a vehicle. If anyone contacts you requesting payment in Atlas\u2019s name, do not pay and report it via the Report an Issue tool.",
    ],
  },
  {
    heading: "4. Accounts and eligibility",
    body: [
      "You must provide accurate registration information and are responsible for activity under your account. You must accept these Terms to create an account. We record the version of the Terms you accepted and the date and time of acceptance.",
      "You must be of the age of majority in your jurisdiction to create an account.",
    ],
  },
  {
    heading: "5. Third-party information",
    body: [
      "Vehicle information originates from external sources. Atlas does not control original listings and cannot guarantee that third-party information is complete, accurate, current or free from errors. You are responsible for independently verifying any vehicle before acting on it. See the Data & Third-Party Sources notice.",
    ],
  },
  {
    heading: "6. Acceptable use",
    body: [
      "You agree not to misuse Atlas, including by scraping at scale, attempting to disrupt the service, misrepresenting your identity, or using Atlas to defraud others.",
    ],
  },
  {
    heading: "7. Dealer / source submission terms",
    body: [
      "Legitimate dealers, dealership groups and automotive websites may request that their inventory source be considered for inclusion. Submitting a source is a request for consideration only and does not guarantee inclusion.",
      "Atlas retains full editorial and data control over whether a source is reviewed, verified, activated or suspended (states: Submitted \u2192 Under Review \u2192 Verified \u2192 Active, and may be Suspended). A submitted source is not automatically trusted or verified. No listing, placement or verification fee is charged, and no payment is processed through Atlas.",
      "By submitting a source you confirm you are authorised to represent the business and that the information provided is accurate.",
    ],
  },
  {
    heading: "8. Disclaimers and liability",
    body: [
      "Atlas is provided on an \u201cas is\u201d and \u201cas available\u201d basis for prototype purposes. To the extent permitted by applicable law, Atlas is not liable for losses arising from reliance on third-party information or from any transaction with a seller or source.",
    ],
  },
  {
    heading: "9. Governing law",
    body: [
      "These Terms are intended to be governed by the laws of the Netherlands and applicable European Union law, subject to confirmation by qualified Netherlands/EU counsel before production launch.",
    ],
  },
  {
    heading: "10. Changes to these Terms",
    body: [
      "We may update these Terms and will change the version identifier when we do. Continued use after an update, or acceptance of a new version at sign-in where required, constitutes acceptance of the updated Terms.",
    ],
  },
];

export default function LegalTerms() {
  return (
    <LegalLayout
      testid="legal-terms"
      currentPath="/legal/terms"
      title="Terms of Use"
      intro="The terms that govern your use of Atlas, including dealer/source submission terms. Draft, pending Netherlands/EU legal review."
      sections={SECTIONS}
    />
  );
}
